import {APP_CONFIG} from "../../config";
import {Utils} from "../../helpers/utils";
import EventBus from "../../bus/events";
import store from '../store';
import {axios} from '../../bootstrap';

export const projects = {
    state: {
        createProjectStatus: false,
        updateProjectStatus: false,
        projectCreated: false,
        invitedUserDialogVisible: false,
        projects: [],
        project: {},
        projectUser: {},
        projectValidationErrors: {},
    },
    mutations: {

        setInvitedUserDialogVisible(state, value) {
            state.invitedUserDialogVisible = value
        },

        setCreateProjectStatus(state, value) {
            state.createProjectStatus = value
        },

        setUpdateProjectStatus(state, value) {
            state.updateProjectStatus = value
        },
        /**
         *
         * @param state
         * @param value
         */
        setProjectCreated(state, value) {
            state.projectCreated = value
        },
        /**
         *
         * @param state
         * @param projects
         */
        setProjects(state, projects) {
            state.projects = projects
        },
        /**
         *
         * @param state
         * @param project
         */
        setProject(state, project) {
            state.project = project;
            const user = store.getters.getAuthenticatedUser,
                members = project.members.data;
            if (Array.isArray(members)) {
                members.forEach((member) => {
                    if (user.email === member.email) {
                        state.projectUser = member;
                    }
                })
            }
        },
        /**
         *
         * @param state
         * @param user
         */
        setProjectUser(state, user) {
            state.projectUser = user;
        },

        /**
         *
         * @param state
         * @param errors
         */
        setProjectValidationErrors(state, errors) {
            state.projectValidationErrors = errors;
        }
    },
    getters: {
        /**
         *
         * @param state
         * @returns {*|boolean|string}
         */
        getCreateProjectStatus(state) {
            return state.createProjectStatus;
        },

        getInvitedUserDialogVisible(state) {
            return state.invitedUserDialogVisible;
        },

        getProjectUser(state) {
            return state.projectUser
        },

        getProjectCreated(state) {
            return state.projectCreated;
        },
        /**
         * Get projects from the API backend
         *
         * @param state
         * @returns {*|boolean|string}
         */
        getProjects(state) {
            return state.projects;
        },

        /**
         * Get project from the store
         *
         * @param state
         * @returns {*|boolean|string}
         */
        getProject(state) {
            return state.project;
        },
        /**
         *  Get status of the project update request.
         *  If true the request is in progress ele finished or not initiated
         *
         * @param state
         * @return {boolean|string}
         */
        getUpdateProjectStatus(state) {
            return state.updateProjectStatus
        },

        /**
         * Get validation errors
         *
         * @param state
         * @return Object
         */
        getProjectValidationErrors(state) {
            return state.projectValidationErrors;
        }
    },
    actions: {
        createProject({commit}, payload) {
            commit('setCreateProjectStatus', true);
            axios.post(APP_CONFIG.URL + 'projects', payload).then((response) => {
                commit('setProjectCreated', true);
                commit('setProject', response.data.data);
                EventBus.$emit('project-created', response.data.data);
            }).catch((error) => {
                commit('setCreateProjectStatus', false);
                if (error.response && error.response.status === 422) {
                    Utils.notify({
                        type: 'error',
                        message: error.response.data.message,
                        title: 'Error creating project'
                    })
                }
            });
        },
        updateProject({dispatch, commit}, payload) {
            commit('setUpdateProjectStatus', true);
            axios.patch(`${APP_CONFIG.URL}projects/${payload.id}`, payload).then((response) => {
                EventBus.$emit('project-updated', response.data);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setProjectValidationErrors', error.response.data.errors);
                }
                Utils.notify({
                    type: 'error',
                    message: error.response.data.message,
                    title: 'Error updating project'
                })
            }).finally(() => {
                commit('setUpdateProjectStatus', false);
            });
        },

        getProjects({commit}, params) {
            commit('setLoadingStatus', true);
            axios.get(APP_CONFIG.URL + 'web/projects?page=' + params.page + '&search=' + params.query).then((response) => {
                let data = response.data.data;
                let params = [];
                if (typeof data === 'object') {
                    params = Object.values(data)
                } else {
                    for (let project of data.values()) {
                        params.push(project)
                    }
                }
                response.data.data = params;
                commit('setProjects', response.data);
                commit('setLoadingStatus', false);
            })
        },

        findProject({commit}, payload) {
            axios.get(`${APP_CONFIG.URL}projects/${payload.project}?include=members`).then((response) => {
                commit('setProject', response.data.data);
                EventBus.$emit('project-loaded', response.data.data);
            })
        },
        /**
         *
         * @param commit
         * @param payload
         */
        sendCreditCardToken({commit}, payload) {
            axios.post('projects/payments/process-card', {
                token: payload.token,
                projectId: payload.project
            }).then(response => {

            })
        }
    }
};
